<template>
  <div :id="'myChart'+index" :style="{width: '100%', height: '200px',margin: '0 0 40px 0'}"></div>
</template>
<script>
import { Line } from "vue-chartjs";

export default {
  name: "LineChart",
  extends: Line,
  props: ["labels", "label", "data", "options", "index"],
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("myChart" + this.index)
      );
      // 绘制图表
      myChart.setOption({
        title: { 
          text: this.label,
          textStyle:{
            fontSize:"16",
            lineHeight:"18",
          }
        },
        tooltip: {
          confine:true,
          show:true,
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          },
          axisPointer: {
            lineStyle: {
              width: 1,
              color: "#0000001a"
            }
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#F7B500"
          },
          formatter: function(params) {
            var res = "<div><div>"+params[0].name+"</div><div>"+params[0].seriesName.substr(3,20)+": "+params[0].data+"</div></div>";
            return res;
          }
        },
        grid:{
          top:50,
          bottom:30,
          left:36,
          right:20,
        },
        xAxis: {
          data: this.labels,
          axisPointer: {
            show: true,
          },
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel:{
              interval:7,
              fontSize:10,
              showMaxLabel:true,
              color:'rgba(0, 0, 0, 0.3)'
            }
        },
        yAxis: {
          min:'dataMin',
          splitNumber:3,
            axisLine:{
              show:false
            },
             axisTick:{
               show:false
             },
            splitLine:{
              show:false
            },
            axisLabel: {
              showMinLabel:false,
              formatter: function (value,index) {
                if (value > 1000) {
                  return value / 1000 + 'k';
                } else {
                  return value
                }
              },
              fontSize:10,
              color:'rgba(0, 0, 0, 0.3)'
            }
        },
        series: [
          {
            name: this.label,
            type: "line",
            symbol: "none",
            smooth:true,
            /* 填充颜色 */
            itemStyle: {
              normal: {
                /* 线条颜色 */
                lineStyle: {
                  color: "#000"
                }
              }
            },
            data: this.data
          }
        ]
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/LineChart.vue